import { useUtm } from "~/composables/Utm";
import { md5 } from "js-md5";

export const useContact = (digitalOrderStep = null) => {

  const utm = useUtm();
  const backend = useBackend();
  const route = useRoute();
  const salesManago = useSalesManago();

  const { analyticsLayer } = useAnalytics();

  const submit = (formData,isEmbed = false) => {
    const postLeasePage = route.path === "/samochody-poleasingowe" || route.query.state === "Poleasingowe" || formData.value.state === "Poleasingowy"
    const entryUrl = useCookie('entry_url')
    
    return new Promise(async resolve => {

      const data = {
        mail: formData.value.mail,
        name: formData.value.name,
        phone: formData.value.phone,
        agr1: formData.value.agr_p ? 1 : 0,
        agr2: formData.value.agr_m ? 1 : 0,
        url: utm.getUrlWithUtmParameters(),
        brand: formData.value.brand,
        model: formData.value.model,
        body: formData.value.body,
        options: formData.value.options,
        entry_url: entryUrl.value,
        ...(postLeasePage ? { action: 'pl' } : {}),
        
        // calculator data:
        year: formData.value.year,
        state: formData.value.state,
        installment: formData.value.installment,
        price: formData.value.price,
        repurchase: formData.value.repurchase,
        initialFee: formData.value.initialFee,
        duration: formData.value.duration,
        clientType: formData.value.clientType,
      }
      if (formData.value.endpoint === 'organization-person-create') {
        data.organization_nip = formData.value.nip;
        data.organization_name = formData.value.companyName;
        data.organization_phone = formData.value.phone;
        data.organization_email = formData.value.mail;
        data.endpoint = 'organization-person-create';
        data.label_id = 4124
      }
      if(formData.value.rp_accounting) {
        data.organization_nip = formData.value.nip;
        data.organization_name = formData.value.companyName;
        data.organization_phone = formData.value.phone;
        data.lead_title = `Księgowi polecają: ${formData.value.name}`;
        data.conversion_url = `https://vehis.pl${formData.value.currentUrl}`;
        data.source = 'Afiliacje CC'
      }

      if(formData.value?.source) {
        data.source = formData.value.source
      }
      const result = await backend.sendContactForm(data,isEmbed)
      if(result?.data?.error || result.status !== 200) {
        resolve(false);
        return;
      }
      
      if(isEmbed){
        resolve(true);
      }

      // salesmanago part
      let contactId = result.data.data.data.data?.contact_id;
      salesManago.setCookie(contactId);
      await salesManago.sendEvent('OFFER', formData.value.product_id);
    
      // end of salesmanago

      let transactionId = result.data.data.data.data.id;
      if (data.endpoint !== 'organization-person-create') {
      const formTypes = {
        model: 'samochody',
        brand: 'samochody',
        cars: 'wybierz',
        offer: 'oferta',
        decide: 'pobierz',
        index: 'home',
        search: 'wyszukaj',
        "static-offer-consumer": 'konsument',
        "static-offer-entrepreneur":"przedsiebiorca",
        "static-offer": "offer",
      }

      const formType = formData.value.formType || formTypes[route.name] || route.name;

      if (digitalOrderStep) {
        let eventName = `trans_form_step${digitalOrderStep}_help`
        analyticsLayer({
          'event': eventName,
          'phone': formData.value.phone,
          'transactionId' : transactionId,
        })
      }

      analyticsLayer({
        'event': 'generate_lead',
        'form_type' : formType,
        'transactionId' : transactionId,
        'email' : data.mail,
        'md5_email_hash': data?.mail ? md5(data.mail.toLowerCase().trim()) : "",
        'phone' : data.phone,
        'brand': data.brand,
        'model': data.model,
        'body': data.body,
        'product_id': formData.value.product_id
      });
    }
      resolve(true);
    })
  }

  return {
    submit
  }

}
